<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-06-06 20:04:17
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-06-06 20:05:50
-->
<template>
  <el-dialog
    title="请联系管理员完成授权"
    width="25%"
    show-close
    :visible.sync="tipsDialog"
  >
    <p>授权后即可同步所有团长活动</p>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="tipsDialog = false">我知道了</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      tipsDialog: false,
      content: "",
    };
  },
  methods: {
    initTips(value) {
      this.content = value;
      this.tipsDialog = true;
    },
  },
};
</script>